import { BUTTON_LABELS } from '@/constants';
import { cn } from '@/utils';
import { Icon, Button } from '@/components';
import { showMoreButtonStyles } from '../ScoreHistoryCard.styles';
import React from 'react';

/**
 * Props for the ScoreHistoryCardShowMoreButton component.
 */
interface ScoreHistoryCardShowMoreButtonProps {
  /** Accessible label describing the expand/collapse action for screen readers. */
  ariaLabel: string;
  /** The id of the list element this button controls; used for aria-controls. */
  controlsId?: string;
  /** Whether the list is currently expanded. Controls button label and caret rotation. */
  isExpanded: boolean;
  /** Called when the button is clicked. */
  onClick: () => void;
}

/**
 * Toggle button that expands or collapses the score history list.
 * Renders "Show more" / "Show less" text with an animated caret icon.
 */
export const ScoreHistoryCardShowMoreButton: React.FC<ScoreHistoryCardShowMoreButtonProps> = ({
  ariaLabel,
  controlsId,
  isExpanded,
  onClick,
}) => (
  <div className="-ml-1">
    <Button
      aria-controls={controlsId}
      aria-expanded={isExpanded}
      aria-label={ariaLabel}
      className={showMoreButtonStyles}
      onClick={onClick}
      variant="link"
    >
      <span className="pointer-events-none flex items-center gap-1">
        <span className="pointer-events-none">
          {isExpanded ? BUTTON_LABELS.SHOW_LESS : BUTTON_LABELS.SHOW_MORE}
        </span>
        <Icon
          name="CaretDown"
          size={12}
          className={cn('transition-transform duration-200', isExpanded && 'rotate-180')}
        />
      </span>
    </Button>
  </div>
);

ScoreHistoryCardShowMoreButton.displayName = 'ScoreHistoryCardShowMoreButton';

export default ScoreHistoryCardShowMoreButton;
